import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AddService from '@/views/services/add-service.vue'
import ServicesIndex from '@/views/services/index.vue'
import ServiceDetails from '@/views/services/service-details.vue'

const servicesRoutes: RouteRecordRaw[] = [
  {
    path: '/services',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'services', component: ServicesIndex },
      { path: 'add', name: 'Add-Service', component: AddService },
      { path: ':slug', name: 'Service-Details', component: ServiceDetails, props: true },
    ],
  },
]

export default servicesRoutes
